import requestService from "../requestService";
import store from '@/store';

export default {
    async createSocialLink(form) {
        const response = await requestService.post(`/admin/social_links/create`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async updateSocialLink(uuid, form) {
        const response = await requestService.post(`/admin/social_links/${uuid}/update`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async getSocialLinks() {
        const response = await requestService.get(`/social_links`)
        return response?.data
    },
    async getSocialLink(id) {
        const response = await requestService.get(`/admin/social_links/${id}`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async deleteSocialLink(id) {
        const response = await requestService.delete(`/admin/social_links/${id}/delete`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
}